import { RouteConfig } from 'vue-router';
import {metaRequireAuth} from '@/router/meta-constants';

const authenticatedRoutes: Array<RouteConfig> = [
    {
        path: '/ticket',
        name: 'Home',
        meta: metaRequireAuth,
        component: () => import(/* webpackChunkName: "authenticate" */ '@/views/pos/ticket/index.vue')
    },
    {
        path: '/ticket',
        name: 'Ticket',
        meta: metaRequireAuth,
        component: () => import(/* webpackChunkName: "authenticate" */ '@/views/pos/ticket/index.vue')
    },
    {
        path: '/scanning-qrcode',
        name: 'ScanningQRCode',
        meta: metaRequireAuth,
        component: () => import(/* webpackChunkName: "authenticate" */ '@/views/pos/scanning/qrcode.vue')
    },
    {
        path: '/qrcode-input',
        name: 'QrCodeInput',
        meta: metaRequireAuth,
        component: () => import(/* webpackChunkName: "authenticate" */ '@/views/pos/scanning/qrCodeInput.vue')
    },
    {
        path: '/transaction-success',
        name: 'TransactionSuccess',
        meta: metaRequireAuth,
        component: () => import(/* webpackChunkName: "authenticate" */ '@/views/pos/transaction/TransactionSuccess.vue')
    },
    {
        path: '/transaction-overview',
        name: 'TransactionOverview',
        meta: metaRequireAuth,
        component: () => import(/* webpackChunkName: "authenticate" */ '@/views/pos/transaction/TransactionOverview.vue')
    },
    {
        path: '/transaction-result',
        name: 'TransactionResult',
        meta: metaRequireAuth,
        component: () => import(/* webpackChunkName: "authenticate" */ '@/views/pos/transaction/TransactionResult.vue')
    },
    {
        path: '/scanning-ticket',
        name: 'ScanningTicket',
        meta: metaRequireAuth,
        component: () => import(/* webpackChunkName: "authenticate" */ '@/views/pos/scanning/ticket.vue')
    },
    {
        path: '/ticket-input',
        name: 'TicketInput',
        meta: metaRequireAuth,
        component: () => import(/* webpackChunkName: "authenticate" */ '@/views/pos/scanning/ticketInput.vue')
    },
    {
        path: '/lotto',
        name: 'Lotto',
        meta: metaRequireAuth,
        component: () => import(/* webpackChunkName: "authenticate" */ '@/views/pos/lotto/lotto.vue')
    },
];

export default authenticatedRoutes;
